<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>INDIVIDUELLE NATURSTEINPRODUKTE</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Individuelle Maßanfertigen und Unikate feiern schon seit einiger Zeit ihr Comeback. Der Wunsch etwas Exklusives zu besitzen, was individuell angefertigt wird und somit den persönlichen Geschmack perfekt trifft, ist heutzutage so groß wie nie. Natürlich ist jeder Naturstein von sich aus schon ein Unikat, doch wenn es um individuelle Anfertigungen von Natursteinprodukten geht, sind wir der richtige Ansprechpartner für Sie! </p>
        <hr>
        <h2>Wir fertigen das Natursteinprodukt nach ihren persönlichen Vorstellungen an</h2>
        <p>Von kleinen Alltagsgegenständen über mittelgroße dekorative Elemente bis hin zu größeren Anfertigungen, wie z. B. Naturstein Kamine, können wir fast jedes Produkt durch den Einsatz moderner Technik erstellen. Form und Farbe bestimmen Sie dabei in einem individuellen Beratungsgespräch. <router-link :to="{ name: 'Kontakt' }">Sprechen Sie uns einfach an</router-link> und erfüllen Sie sich den Traum nach exklusiven Natursteinprodukten!</p>
        <hr>
        <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/individuelles/individuell03.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/individuelles/individuell01.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/individuelles/individuell02.jpg"></div>
        </div>
      </article>
    </div>
    </section>
</template>

<script>
export default {
  name: 'IndividuelleProdukte',
  metaInfo: {
    title: 'Individuelle Naturstein Produkte',
    meta:[
      { vmid: 'description', name: 'description', content: "Fensterbänke aus Naturstein setzen im Innenbereich stylische. Im Außenbereich verbinden Natursteinfensterbänke Ästhetik und Funktionalität gleichermaßen. "},
      { vmid: 'keywords', name: 'keywords', content: "Individuelle Natursteinprodukte, individuelle Naturstein Produkte, individuelle Natursteine, individuelle Naturstein Anfertigungen, Naturstein Kamin, Natursteinunikate, Natursteinprodukte, Naturstein Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/individuelle-naturstein-produkte'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/IndividuelleProdukte.vue